import classNames from "classnames";
import {
	PageSectionProps,
	TitleAndContentProps,
} from "../../../../../constants/pageSectionTypes";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";

const WhyNow = ({
	sectionContent,
	className,
}: PageSectionProps<TitleAndContentProps>) => {
	return (
		<section className={classNames("why-now keep-color", className)}>
			<div className="column">
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
			</div>
			<div className="column">
				<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
			</div>
		</section>
	);
};

export default WhyNow;
